import styled from 'styled-components';
import { PropertyItem } from '../../../PropertyGroup';
export var Container = styled.div.withConfig({
  displayName: "OrderByPropertystyles__Container",
  componentId: "keen-query-creator__sc-1mbnpa9-0"
})(["&&&{position:relative;display:inline-flex;flex-direction:column;}"]);
export var DropdownContent = styled.div.withConfig({
  displayName: "OrderByPropertystyles__DropdownContent",
  componentId: "keen-query-creator__sc-1mbnpa9-1"
})(["&&&{width:285px;}"]);
export var StyledPropertyItem = styled(PropertyItem).withConfig({
  displayName: "OrderByPropertystyles__StyledPropertyItem",
  componentId: "keen-query-creator__sc-1mbnpa9-2"
})(["&&&.drag-handle{cursor:grab;display:flex;align-items:center;padding:0 10px;}"]);